import { MDSBannerKind, MDSButtonVariant, MDSIconKind } from "@/mds";
import { FeatureGateBannerQuotaLevel } from "./feature-gate-banner.types";

export interface FeatureGateBannerConfig {
  bannerKind: MDSBannerKind;
  message: string;
  buttonVariant: MDSButtonVariant;
  buttonText: string;
  iconKind: MDSIconKind;
}

export const getFeatureGateBannerConfig = (
  level: FeatureGateBannerQuotaLevel,
  { isPaidPlan }: { isPaidPlan: boolean }
): FeatureGateBannerConfig => {
  switch (level) {
    case FeatureGateBannerQuotaLevel.Exceeded:
      return {
        bannerKind: MDSBannerKind.Error,
        message: isPaidPlan
          ? "You've reached your plan's monthly usage limit"
          : "You've reached your free usage limits this month",
        buttonVariant: MDSButtonVariant.Danger,
        buttonText: "View plans",
        iconKind: MDSIconKind.InfoCircle,
      };
    case FeatureGateBannerQuotaLevel.Warning:
    default:
      return {
        bannerKind: MDSBannerKind.Info,
        message: isPaidPlan
          ? "You're nearing your plan's monthly usage limit"
          : "You're nearing your free usage limits this month",
        buttonVariant: MDSButtonVariant.Transparent,
        buttonText: "View plans",
        iconKind: MDSIconKind.InfoCircle,
      };
  }
};
